// src/ConsumerApp/api/checkout/checkout.service.js
import { apiClient } from '../apiClient';

export const CheckoutService = {
  /**
   * Process Instant Checkout Payment
   * Endpoint: /brickbucket/customer/salesorder.process-instant-checkout-payment
   */
  processInstantCheckout: async (payload) => {
    const response = await apiClient.post(
      '/brickbucket/customer/salesorder/process-instant-checkout-payment',
      payload
    );
    return response.data || response;
  },
};